import React, {useState} from 'react';
import styled from 'styled-components';
import {Form} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import {InputNumber} from 'components';

const OfficesNumberFilter = () => {
  const {query, setQuery} = useSearchParams();
  const {officesNumber} = query;
  const [from, setFrom] = useState(officesNumber?.from);
  const [to, setTo] = useState(officesNumber?.to);

  return (
    <Container>
      <Form.Item>
        <StyledInputNumber
          min={1}
          max={10000}
          value={from}
          onChange={(value) => setFrom(value)}
          onBlur={() => setQuery({officesNumber: {from: from, to: to}})}
        />
        <span> 〜 </span>
        <StyledInputNumber
          min={1}
          max={10000}
          value={to}
          onChange={(value) => setTo(value)}
          onBlur={() => setQuery({officesNumber: {from: from, to: to}})}
        />
      </Form.Item>
    </Container>
  );
};

const Container = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;

const StyledInputNumber = styled(InputNumber)`
  border: 1px solid rgb(217, 217, 217) !important;
  width: 138px;
`;

export default OfficesNumberFilter;
